import {
  Autocomplete,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material"
import { ResponsiveDialog } from "components/ResponsiveDialog/ResponsiveDialog"
import { User } from "graphql/types"

import { StyledButton } from "components/Button/StyledButton"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { enqueueSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { emptyPerson } from "store/store"
import { useLocalStorage } from "utils/useLocalStorage"

type HelpingDialogProps = {
  open: boolean
  onClose: () => void
}

export const HelpingDialog = (props: HelpingDialogProps) => {
  const users = useStoreState((state) => state.users)
  const [user] = useLocalStorage<User>("user", emptyPerson)

  const [examinator, setExaminator] = useState<User | null>(null)
  const { fetchUsers } = useStoreActions((actions) => actions)

  useEffect(() => {
    const loadUsers = async () => {
      try {
        await fetchUsers({ fresh: false })
      } catch (err) {
        console.error("Error loading users:", err)
      }
    }
    loadUsers()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleSave = () => {
    enqueueSnackbar("Diese Funktion ist noch nicht weiter implementiert.", {
      variant: "info",
    })
    if (examinator) {
      setExaminator(null)
    }
    onClose()
  }

  const { open, onClose } = props
  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography>Helfen</Typography>
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          sx={{ mt: 1 }}
          size="small"
          fullWidth
          value={examinator || null}
          id="tags-outlined"
          options={users.filter((employee) => employee.id !== user.id)}
          getOptionLabel={(option) => option?.displayName ?? ""}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.displayName}
            </li>
          )}
          renderInput={(params) => <TextField {...params} />}
          onChange={(_, value) => {
            if (value) {
              setExaminator(value)
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <StyledButton
          buttonType="cancel"
          variant="contained"
          onClick={onClose}
        />
        <StyledButton
          buttonType="save"
          variant="contained"
          onClick={handleSave}
          disabled={!examinator}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
